import { trackDownloadClick } from '../services/analytics';

export default function Footer() {
  return (
    <footer className="bg-[#FFF6EF]">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 lg:grid-cols-4 md:px-8">
        <div>
          <a href="/" className="font-[Nunito] text-2xl font-extrabold text-[#5B3FA6]">
            🚽 PottyPal
          </a>
          <p className="mt-3 text-[#6F655E]">AI-powered potty training for modern parents.</p>
          <div className="mt-4 flex gap-2 text-xl text-[#7D6DAF]">
            <span>◯</span>
            <span>◯</span>
            <span>◯</span>
          </div>
        </div>
        <div>
          <h4 className="font-[Nunito] text-lg font-bold text-[#4A3F66]">Product</h4>
          <ul className="mt-3 space-y-2 text-[#6F655E]">
            <li><a href="#features">Features</a></li>
            <li><a href="#how-it-works">How it works</a></li>
            <li><a href="#pricing">Pricing</a></li>
            <li>
              <a href="#playstore" onClick={() => trackDownloadClick('footer')}>
                Download
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-[Nunito] text-lg font-bold text-[#4A3F66]">Support</h4>
          <ul className="mt-3 space-y-2 text-[#6F655E]">
            <li><a href="#faq">FAQ</a></li>
            <li><a href="/support">Support</a></li>
            <li><a href="mailto:support@logicalflows.com">Contact Us</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/terms">Terms of Service</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-[Nunito] text-lg font-bold text-[#4A3F66]">Legal</h4>
          <ul className="mt-3 space-y-2 text-[#6F655E]">
            <li>© 2026 LogicalFlows. All rights reserved.</li>
            <li>PottyPal is not medical advice.</li>
            <li>support@logicalflows.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#EADFD3] py-4 text-center text-sm text-[#7B716A]">Made with ❤️ for parents everywhere</div>
    </footer>
  );
}

